export const META = {
  years: null,
  months: {
    ru: [
      'январь',
      'февраль',
      'март',
      'апрель',
      'май',
      'июнь',
      'июль',
      'август',
      'сентябрь',
      'октябрь',
      'ноябрь',
      'декабрь',
    ],
    kk: [
      'қаңтар',
      'ақпан',
      'наурыз',
      'сәуір',
      'мамыр',
      'маусым',
      'шілде',
      'тамыз',
      'қыркүйек',
      'қазан',
      'қараша',
      'желтоқсан',
    ],
  },
  rows: {
    income: [
      {
        row_id: 101,
        sort_order: 1,
        code: '1',
        name_ru: 'Налоговые поступления',
        name_kk: 'Салықтық түсімдер',
        type: 'НАЛОГОВЫЕ ПОСТУПЛЕНИЯ',
        type_kk: 'Салықтық түсімдер',
      },
      {
        row_id: 102,
        sort_order: 2,
        code: '2',
        name_ru: 'Неналоговые поступления',
        name_kk: 'Салықтық емес түсімдер',
        type: 'НЕНАЛОГОВЫЕ ПОСТУПЛЕНИЯ',
        type_kk: 'Салықтық емес түсімдер',
      },
      {
        row_id: 103,
        sort_order: 3,
        code: '3',
        name_ru: 'Поступления от продажи основного капитала',
        name_kk: 'Негізгі капиталды сатудан түсетін түсімдер',
        type: 'ПОСТУПЛЕНИЯ ОТ ПРОДАЖИ ОСНОВНОГО КАПИТАЛА',
        type_kk: 'Негізгі капиталды сатудан түсетін түсімдер',
      },
      {
        row_id: 104,
        sort_order: 4,
        code: '4',
        name_ru: 'Поступления трансфертов',
        name_kk: 'Трансферттердің түсімдері',
        type: 'ПОСТУПЛЕНИЯ ТРАНСФЕРТОВ',
        type_kk: 'Трансферттердің түсімдері',
      },
      {
        row_id: 105,
        sort_order: 5,
        code: '5',
        name_ru: 'Погашение бюджетных кредитов',
        name_kk: 'Бюджеттік кредиттерді өтеу',
        type: 'ПОГАШЕНИЕ БЮДЖЕТНЫХ КРЕДИТОВ',
        type_kk: 'Бюджеттік кредиттерді өтеу',
      },
      {
        row_id: 106,
        sort_order: 6,
        code: '6',
        name_ru: 'Поступления от продажи финансовых активов государства',
        name_kk: 'Мемлекеттің қаржы активтерін сатудан түсетін түсімдер',
        type: 'ПОСТУПЛЕНИЯ ОТ ПРОДАЖИ ФИНАНСОВЫХ АКТИВОВ ГОСУДАРСТВА',
        type_kk: 'Мемлекеттің қаржы активтерін сатудан түсетін түсімдер',
      },
      {
        row_id: 107,
        sort_order: 7,
        code: '7',
        name_ru: 'Поступления займов',
        name_kk: 'Қарыздар түсімі',
        type: 'ПОСТУПЛЕНИЕ ЗАЙМОВ',
        type_kk: 'Қарыздар түсімі',
      },
      {
        row_id: 108,
        sort_order: 8,
        code: '8',
        name_ru: 'Остатки бюджетных средств на конец отчетного периода',
        name_kk: 'Есепті кезеңнің соңындағы бюджет қаражатының қалдықтары',
        type: 'ИСПОЛЬЗУЕМЫЕ ОСТАТКИ БЮДЖЕТНЫХ СРЕДСТВ',
        type_kk: 'Пайдаланылатын бюджет қаражатының қалдықтары',
      },
      {
        row_id: 109,
        sort_order: 9,
        code: '',
        name_ru: 'ИСПОЛЬЗУЕМЫЕ ОСТАТКИ БЮДЖЕТНЫХ СРЕДСТВ',
        name_kk: 'Пайдаланылатын бюджет қаражатының қалдықтары',
        type: 'ИСПОЛЬЗУЕМЫЕ ОСТАТКИ БЮДЖЕТНЫХ СРЕДСТВ',
        type_kk: 'Пайдаланылатын бюджет қаражатының қалдықтары',
      },
      {
        row_id: 110,
        sort_order: 10,
        code: '',
        name_ru: 'Остатки бюджетных средств на начало финансового года',
        name_kk: 'Қаржы жылының басындағы бюджет қаражатының қалдықтары',
        type: 'ИСПОЛЬЗУЕМЫЕ ОСТАТКИ БЮДЖЕТНЫХ СРЕДСТВ',
        type_kk: 'Пайдаланылатын бюджет қаражатының қалдықтары',
      },
    ],
    expense: [
      {
        row_id: 201,
        sort_order: 1,
        code: '01',
        name_ru: 'Государственные услуги общего характера',
        name_kk: 'Жалпы сипаттағы мемлекеттік қызметтер',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 202,
        sort_order: 2,
        code: '02',
        name_ru: 'Оборона',
        name_kk: 'Қорғаныс',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 203,
        sort_order: 3,
        code: '03',
        name_ru:
          'Общественный порядок, безопасность, правовая, судебная, уголовно-исполнительная деятельность',
        name_kk: 'Қоғамдық тәртіп, қауіпсіздік, құқықтық, сот, қылмыстық-атқару қызметі',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 204,
        sort_order: 4,
        code: '04',
        name_ru: 'Образование',
        name_kk: 'Білім беру',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 205,
        sort_order: 5,
        code: '05',
        name_ru: 'Здравоохранение',
        name_kk: 'Денсаулық сақтау',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 206,
        sort_order: 6,
        code: '06',
        name_ru: 'Социальная помощь и социальное обеспечение',
        name_kk: 'Әлеуметтік көмек және әлеуметтік қамсыздандыру',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 207,
        sort_order: 7,
        code: '07',
        name_ru: 'Жилищно-коммунальное хозяйство',
        name_kk: 'Тұрғын үй-коммуналдық шаруашылық',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 208,
        sort_order: 8,
        code: '08',
        name_ru: 'Культура, спорт, туризм и информационное пространство',
        name_kk: 'Мәдениет, спорт, туризм және ақпараттық кеңістік',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 209,
        sort_order: 9,
        code: '09',
        name_ru: 'Топливно-энергетический комплекс и недропользование',
        name_kk: 'Отын-энергетика кешені және жер қойнауын пайдалану',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 210,
        sort_order: 10,
        code: '10',
        name_ru:
          'Сельское, водное, лесное, рыбное хозяйство, особо охраняемые природные территории, охрана окружающей среды и животного мира, земельные отношения',
        name_kk:
          'Ауыл, су, орман, балық шаруашылығы, ерекше қорғалатын табиғи аумақтар, қоршаған ортаны және жануарлар дүниесін қорғау, жер қатынастары',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 211,
        sort_order: 11,
        code: '11',
        name_ru: 'Промышленность, архитектурная, градостроительная и строительная деятельность',
        name_kk: 'Өнеркәсіп, сәулет, қала құрылысы және құрылыс қызметі',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 212,
        sort_order: 12,
        code: '12',
        name_ru: 'Транспорт и коммуникации',
        name_kk: 'Көлік және коммуникация',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 213,
        sort_order: 13,
        code: '13',
        name_ru: 'Прочие',
        name_kk: 'Өзгелер',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 214,
        sort_order: 14,
        code: '14',
        name_ru: 'Обслуживание долга',
        name_kk: 'Борышқа қызмет көрсету',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 215,
        sort_order: 15,
        code: '15',
        name_ru: 'Трансферты',
        name_kk: 'Трансферттер',
        type: 'II. ЗАТРАТЫ',
        type_kk: 'II. ШЫҒЫНДАР',
      },
      {
        row_id: 216,
        sort_order: 16,
        code: '07',
        name_ru: 'Жилищно-коммунальное хозяйство',
        name_kk: 'Тұрғын үй-коммуналдық шаруашылық',
        type: 'БЮДЖЕТНЫЕ КРЕДИТЫ',
        type_kk: 'Бюджеттік кредиттер',
      },
      {
        row_id: 217,
        sort_order: 17,
        code: '10',
        name_ru:
          'Сельское, водное, лесное, рыбное хозяйство, особо охраняемые природные территории, охрана окружающей среды и животного мира, земельные отношения',
        name_kk:
          'Ауыл, су, орман, балық шаруашылығы, ерекше қорғалатын табиғи аумақтар, қоршаған ортаны және жануарлар дүниесін қорғау, жер қатынастары',
        type: 'БЮДЖЕТНЫЕ КРЕДИТЫ',
        type_kk: 'Бюджеттік кредиттер',
      },
      {
        row_id: 218,
        sort_order: 18,
        code: '13',
        name_ru: 'Прочие',
        name_kk: 'Өзгелер',
        type: 'БЮДЖЕТНЫЕ КРЕДИТЫ',
        type_kk: 'Бюджеттік кредиттер',
      },
      {
        row_id: 219,
        sort_order: 19,
        code: '13',
        name_ru: 'Прочие',
        name_kk: 'Өзгелер',
        type: 'ПРИОБРЕТЕНИЕ ФИНАНСОВЫХ АКТИВОВ',
        type_kk: 'Қаржы активтерін сатып алу',
      },
      {
        row_id: 220,
        sort_order: 20,
        code: '16',
        name_ru: 'Погашение займов',
        name_kk: 'Қарыздарды өтеу',
        type: 'ПОГАШЕНИЕ ЗАЙМОВ',
        type_kk: 'Қарыздарды өтеу',
      },
    ],
  },
};

/* ================= ВВЕДЁННЫЕ ПЕРИОДЫ (демо, 2024) =================
   Ключ периода — 'M.YYYY'. Массив значений в порядке META.rows[side]
   ([план, исполнение] по каждой строке). Годовые итоги совпадают с итогами
   действующих дашбордов «Доходы»/«Расходы», помесячные — накопительным итогом.
   В реальном API это отдаёт /periods (итоги) и /periods/{key} (матрица). */
export const ENT = {
  income: {
    1.2024: [
      [1273860.6, 1083755.7],
      [1254.0, 1425.8],
      [760.4, 761.2],
      [20652.8, 15047.9],
      [0.0, 0.0],
      [1.4, 1.2],
      [15.4, 13.1],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    2.2024: [
      [39489678.6, 39882210.7],
      [38872.7, 52468.4],
      [23573.6, 28011.1],
      [640237.6, 553762.7],
      [0.0, 0.0],
      [43.7, 44.0],
      [477.2, 480.4],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    3.2024: [
      [41612779.6, 42266473.3],
      [40962.7, 55605.0],
      [24841.0, 29685.7],
      [674659.0, 586868.1],
      [0.0, 0.0],
      [46.0, 46.6],
      [502.8, 509.1],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    4.2024: [
      [47345152.3, 47902003.0],
      [46605.5, 63019.1],
      [28263.0, 33643.8],
      [767596.8, 665117.2],
      [0.0, 0.0],
      [52.4, 52.8],
      [572.1, 577.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    5.2024: [
      [76431636.1, 77596909.9],
      [75237.6, 102085.2],
      [45626.3, 54500.0],
      [1239169.6, 1077429.6],
      [0.0, 0.0],
      [84.6, 85.6],
      [923.5, 934.7],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    6.2024: [
      [76856256.3, 78247163.3],
      [75655.5, 102940.6],
      [45879.8, 54956.7],
      [1246053.9, 1086458.3],
      [0.0, 0.0],
      [85.0, 86.3],
      [928.7, 942.5],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    7.2024: [
      [77493186.6, 78897416.8],
      [76282.5, 103796.1],
      [46260.0, 55413.4],
      [1256380.3, 1095487.1],
      [0.0, 0.0],
      [85.7, 87.0],
      [936.4, 950.3],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    8.2024: [
      [132906122.7, 136119719.1],
      [130829.7, 179076.8],
      [79339.1, 95603.3],
      [2154778.3, 1890016.2],
      [0.0, 0.0],
      [147.0, 150.2],
      [1605.9, 1639.6],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    9.2024: [
      [135453843.9, 138720732.8],
      [133337.7, 182498.6],
      [80860.0, 97430.1],
      [2196084.0, 1926131.1],
      [0.0, 0.0],
      [149.9, 153.0],
      [1636.7, 1670.9],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    10.2024: [
      [137576944.9, 141104995.4],
      [135427.6, 185635.3],
      [82127.4, 99104.7],
      [2230505.4, 1959236.5],
      [0.0, 0.0],
      [152.2, 155.7],
      [1662.4, 1699.6],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    11.2024: [
      [206153107.3, 211115615.2],
      [202932.4, 277740.1],
      [123064.3, 148276.4],
      [3342315.9, 2931330.8],
      [0.0, 0.0],
      [228.1, 232.9],
      [2491.0, 2542.9],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    12.2024: [
      [212310100.2, 216751145.0],
      [208993.2, 285154.1],
      [126739.8, 152234.5],
      [3442137.9, 3009579.9],
      [0.0, 0.0],
      [234.9, 239.1],
      [2565.4, 2610.8],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
  },
  expense: {
    1.2024: [
      [40274.5, 33488.6],
      [468339.7, 390262.6],
      [6.0, 5.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [28151.4, 23454.3],
      [144695.5, 106656.9],
      [14426.0, 11989.5],
      [0.0, 0.0],
      [6324.2, 5269.8],
      [20874.4, 17395.3],
      [91962.0, 75162.3],
      [146774.2, 119877.6],
      [177.8, 148.2],
      [1686246.2, 1405205.2],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    2.2024: [
      [67124.1, 53581.8],
      [780566.2, 624420.2],
      [10.0, 8.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [46919.1, 37526.9],
      [241159.1, 170651.1],
      [24043.3, 19183.2],
      [0.0, 0.0],
      [10540.4, 8431.7],
      [34790.6, 27832.4],
      [153270.0, 120259.6],
      [244623.7, 191804.2],
      [296.4, 237.1],
      [2810410.4, 2248328.3],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    3.2024: [
      [107398.6, 87070.4],
      [1248905.9, 1014682.9],
      [16.0, 13.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [75070.5, 60981.2],
      [385854.6, 277308.0],
      [38469.3, 31172.7],
      [0.0, 0.0],
      [16864.6, 13701.6],
      [55665.0, 45227.7],
      [245232.0, 195421.9],
      [391397.9, 311681.9],
      [474.2, 385.3],
      [4496656.6, 3653533.5],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    4.2024: [
      [157741.6, 127256.7],
      [1834330.6, 1482998.0],
      [23.5, 19.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [110259.8, 89126.4],
      [566723.9, 405296.3],
      [56501.8, 45560.1],
      [0.0, 0.0],
      [24770.0, 20025.4],
      [81758.0, 66102.1],
      [360184.5, 285616.6],
      [574865.7, 455535.0],
      [696.5, 563.1],
      [6604464.4, 5339779.7],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    5.2024: [
      [865900.9, 334886.0],
      [10069304.0, 3902626.4],
      [129.0, 50.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [605255.9, 234543.0],
      [3110952.4, 1066569.3],
      [310158.6, 119895.0],
      [0.0, 0.0],
      [135971.2, 52698.4],
      [448799.0, 173952.8],
      [1977183.0, 751622.7],
      [3155645.7, 1198776.4],
      [3823.3, 1481.8],
      [36254294.2, 14052051.9],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    6.2024: [
      [912887.8, 810424.1],
      [10615700.3, 9444355.9],
      [136.0, 121.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [638099.2, 567594.1],
      [3279763.8, 2581097.6],
      [326988.9, 290145.8],
      [0.0, 0.0],
      [143349.5, 127530.0],
      [473152.4, 420965.8],
      [2084472.0, 1818926.9],
      [3326882.3, 2901038.9],
      [4030.8, 3586.0],
      [38221581.4, 34005965.6],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    7.2024: [
      [943093.6, 890796.8],
      [10966955.1, 10380986.2],
      [140.5, 133.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [659212.8, 623884.5],
      [3388285.4, 2837074.2],
      [337808.4, 318920.6],
      [0.0, 0.0],
      [148092.7, 140177.6],
      [488808.2, 462714.4],
      [2153443.5, 1999316.4],
      [3436963.0, 3188745.3],
      [4164.1, 3941.6],
      [39486266.1, 37378458.1],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    8.2024: [
      [1382756.5, 1346241.7],
      [16079663.7, 15688558.1],
      [206.0, 201.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [966532.6, 942863.0],
      [4967877.5, 4287608.4],
      [495292.0, 481977.7],
      [0.0, 0.0],
      [217132.4, 211847.4],
      [716686.8, 699290.2],
      [3157362.0, 3021523.3],
      [5039248.2, 4819081.2],
      [6105.4, 5956.9],
      [57894454.2, 56489248.6],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    9.2024: [
      [1866050.0, 1851919.6],
      [21699740.4, 21581523.9],
      [278.0, 276.5],
      [0.0, 0.0],
      [0.0, 0.0],
      [1304349.9, 1297023.0],
      [6704223.0, 5898128.0],
      [668403.7, 663019.1],
      [0.0, 0.0],
      [293023.3, 291421.9],
      [967179.2, 961958.9],
      [4260906.0, 4156473.5],
      [6800538.9, 6629233.5],
      [8239.4, 8194.4],
      [78129409.1, 77707847.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    10.2024: [
      [2047285.1, 1915547.9],
      [23807269.1, 22323023.0],
      [305.0, 286.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [1431031.3, 1341586.1],
      [7355352.5, 6100776.2],
      [733320.7, 685799.1],
      [0.0, 0.0],
      [321482.4, 301434.6],
      [1061113.9, 995010.0],
      [4674735.0, 4299281.8],
      [7461022.8, 6857001.1],
      [9039.6, 8476.0],
      [85717517.2, 80377736.9],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    11.2024: [
      [3205175.8, 3137881.8],
      [37272036.0, 36567609.3],
      [477.5, 468.5],
      [0.0, 0.0],
      [0.0, 0.0],
      [2240385.1, 2197668.2],
      [11515347.0, 9993754.0],
      [1148067.6, 1123415.7],
      [0.0, 0.0],
      [503304.4, 493783.6],
      [1661252.1, 1629937.6],
      [7318642.5, 7042704.7],
      [11680781.7, 11232535.0],
      [14152.1, 13884.6],
      [134197096.6, 131667726.3],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
    12.2024: [
      [3356205.0, 3348860.0],
      [39028310.0, 39026263.9],
      [500.0, 500.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [2345953.0, 2345430.3],
      [12057955.0, 10665692.6],
      [1202165.0, 1198949.5],
      [0.0, 0.0],
      [527020.3, 526983.6],
      [1739531.0, 1739527.9],
      [7663500.0, 7516227.0],
      [12231185.0, 11987764.1],
      [14819.0, 14818.1],
      [140520520.0, 140520519.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
      [0.0, 0.0],
    ],
  },
};

META.years = [2024, 2025, 2026, 2027];

export function isDuplicateKey(side, key) {
  return !!ENT[side][key];
}

META.years_with_data = [
  ...new Set(
    Object.keys(ENT.income)
      .concat(Object.keys(ENT.expense))
      .map((k) => +k.split('.')[1])
  ),
].sort((a, b) => a - b);

console.log(Object.keys(ENT.income));
